import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { heightWork, waLink, waMessages } from "@/content/siteContent";
import { Reveal } from "./Reveal";

export default function HeightWork() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="altura" ref={ref} className="relative overflow-hidden py-28 md:py-40" data-testid="height-work-section">
      <motion.div style={{ y }} className="absolute inset-0 scale-125">
        <img
          src={heightWork.image}
          alt="Técnico em rapel realizando manutenção em fachada"
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(13,13,15,.97) 0%, rgba(13,13,15,.82) 55%, rgba(13,13,15,.35) 100%)" }} />
      <div className="stripes absolute left-0 top-0 h-full w-2 opacity-80" />

      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <div className="mb-5 flex items-center gap-4">
              <span className="font-display text-xs font-extrabold tracking-[0.2em] text-steel">CAP. {heightWork.chapter}</span>
              <span className="h-px w-10 bg-brand" />
              <p className="microtitle">{heightWork.microtitle}</p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-paper sm:text-5xl lg:text-6xl" data-testid="height-work-title">
              {heightWork.titleA}
              <br />
              EXIGE <span className="text-brand">{heightWork.highlightWord}</span>
            </h2>
          </Reveal>

          <Reveal delay={0.16}>
            <ul className="mt-10 grid gap-x-10 gap-y-4 sm:grid-cols-2" data-testid="height-work-list">
              {heightWork.items.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm font-semibold text-paper md:text-base">
                  <span className="check-industrial">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.24}>
            <a
              href={waLink(waMessages.rapel)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-industrial mt-12"
              data-testid="height-work-cta"
            >
              {heightWork.cta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
